import { render, staticRenderFns } from "./ExpenseCategoryEditPage.vue?vue&type=template&id=9c796b32&"
import script from "./ExpenseCategoryEditPage.vue?vue&type=script&lang=ts&"
export * from "./ExpenseCategoryEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports